import Layout from "@/views/Layout/index";
// 图标
import questionIcon from "@/assets/img/menu/question.png";
import studentIcon from "@/assets/img/menu/student.png";
import paperIcon from "@/assets/img/menu/paper.png";
import testIcon from "@/assets/img/menu/test.png";
import gradeIcon from "@/assets/img/menu/grade.png";
// 路由组件
import HandsOnBank from "@/views/Bank/HandsOnBank/index.vue";
import TheoryBank from "@/views/Bank/TheoryBank/index.vue";
import BankRecycle from "@/views/Bank/BankRecycle/index.vue";
import StudentsManage from "@/views/StudentsManage/StudentsManage.vue";
import TheoryPaper from "@/views/Paper/Theory/index.vue";
import ExamManage from "@/views/TestManage/TestManage";
import GradeManage from "@/views/GradeManage/GradeManage";
import HandsOnPaper from "@/views/Paper/HandsOn/index.vue";
import SignManage from "@/views/Sign/index.vue";
import UserManage from "@/views/system/user";
export const menuConfig = [
  {
    name: "Question",
    path: "/question",
    meta: {
      title: "题库管理",
      icon: questionIcon
    },
    component: Layout,
    redirect: { path: "/question/handsOn" },
    children: [
      {
        path: "handsOn",
        name: "HandsOnBank",
        component: HandsOnBank,
        meta: {
          title: "实操题库",
          requireAuth: true
        }
      },
      {
        path: "theory",
        name: "TheoryBank",
        component: TheoryBank,
        meta: {
          requireAuth: true,
          title: "理论题库"
        }
      },

      {
        path: "bankRecycle",
        name: "BankRecycle",
        component: BankRecycle,
        meta: {
          requireAuth: true,
          title: "回收站"
        }
      }
    ]
  },
  {
    name: "Paper",
    path: "/paper",
    meta: {
      title: "试卷管理",
      icon: paperIcon
    },
    component: Layout,

    children: [
      {
        path: "theory",
        name: "TheoryPaper",
        component: TheoryPaper,
        meta: {
          title: "理论试卷",
          requireAuth: true
        }
      },
      {
        path: "handsOn",
        name: "HandsOnPaper",
        component: HandsOnPaper,
        meta: {
          title: "实操试卷",
          requireAuth: true
        }
      }
    ]
  },
  {
    name: "Exam",
    path: "/exam",
    meta: {
      title: "考试管理",
      icon: testIcon
    },
    component: Layout,
    children: [
      {
        path: "manage",
        name: "ExamManage",
        component: ExamManage,
        meta: {
          title: "考试信息",
          requireAuth: true
        }
      }
    ]
  },
  {
    name: "Grade",
    path: "/grade",
    meta: {
      title: "成绩管理",
      icon: gradeIcon
    },
    component: Layout,

    children: [
      {
        path: "manage",
        name: "GradeManage",
        component: GradeManage,
        meta: {
          title: "成绩信息",
          requireAuth: true
        }
      }
    ]
  },
  {
    name: "Student",
    path: "/student",
    meta: {
      title: "考生管理",
      icon: studentIcon
    },
    component: Layout,
    children: [
      {
        path: "manage",
        name: "manage",
        component: StudentsManage,
        meta: {
          title: "考生信息",
          requireAuth: true
        }
      }
    ]
  },
  {
    name: "Sign",
    path: "/sign",
    meta: {
      title: "报名管理",
      icon: paperIcon
    },
    component: Layout,
    children: [
      {
        path: "manage",
        name: "manage",
        component: SignManage,
        meta: {
          title: "报名信息",
          requireAuth: true
        }
      }
    ]
  }
  // {
  //   name: "User",
  //   path: "/user",
  //   meta: {
  //     title: "用户管理",
  //     icon: studentIcon
  //   },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "manage",
  //       name: "manage",
  //       component: UserManage,
  //       meta: {
  //         title: "用户信息",
  //         requireAuth: true
  //       }
  //     }
  //   ]
  // }
];



// WEBPACK FOOTER //
// ./src/router/menu.js